import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GenericRichTextDirective } from '@core/jss-utils';
import type { TariffPeriod } from '@innogy/become-a-customer/shared/interfaces';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrustedHtmlPipe } from '@innogy/utils-deprecated';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TranslatePipe } from '@ngx-translate/core';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-aom-costs-per-unit-without-summer-winter',
  templateUrl: './aom-costs-per-unit-without-summer-winter.component.html',
  styleUrls: [
    './aom-costs-per-unit-without-summer-winter.component.essent.scss',
    './aom-costs-per-unit-without-summer-winter.component.ed.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    CSCaptureDirective,
    AutomationIdDirective,
    GenericRichTextDirective,
    TranslatePipe,
    TrustedHtmlPipe,
  ],
})
export class AomCostsPerUnitWithoutSummerWinterComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public tariffPeriods?: TariffPeriod[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public energyTitle?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public deliveryTitle?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public redeliveryTitle?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public redeliveryDescription?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public unit?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public fixedDeliveryCosts?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public fixedDeliveryCostsLabel?: TextField;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public fixedRedeliveryCosts?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public fixedRedeliveryCostsLabel?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public fixedRedeliveryCostsScale?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public expectedPriceTitle?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public isDynamicProduct?: boolean;

  get showRedeliveryCosts() {
    return !!this.fixedRedeliveryCostsScale && !!this.fixedRedeliveryCostsLabel;
  }
}
